// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_2O9","colBig":"styles_colBig__2Rs8r","colSmall":"styles_colSmall__1Npib"};